import React, { memo, ReactNode } from "react";
import { Text, HStack } from "@chakra-ui/react";

interface IHeaderRowProps {
  icon: ReactNode;
  text: string;
}

const HeaderRow = ({ icon, text }: IHeaderRowProps) => (
  <HStack px={2} w="full">
    {icon}
    <Text fontWeight={600} fontSize={18} fontFamily="Outfit">
      {text}
    </Text>
  </HStack>
);

export default memo(HeaderRow);
